"use client";

import { Avatar } from "./Avatar";
import type { MemberProfile } from "@/lib/models";

interface MemberPickerProps {
  members: MemberProfile[];
  onSelect: (member: MemberProfile) => void;
  selectedId?: string;
}

export function MemberPicker({ members, onSelect, selectedId }: MemberPickerProps) {
  return (
    <div className="flex gap-3 overflow-x-auto p-4">
      {members.map((member) => (
        <button
          key={member.uid}
          onClick={() => onSelect(member)}
          className={`flex flex-col items-center gap-1 min-w-[75px] p-2 rounded-lg transition-colors ${
            selectedId === member.uid
              ? "bg-[color:var(--accent-color)]/10"
              : "hover:bg-gray-100 dark:hover:bg-white/5"
          }`}
        >
          <Avatar
            src={member.profile_url}
            alt={member.nickname ?? member.name ?? ""}
            size={40}
          />
          <span className="text-xs text-center truncate w-full">
            {member.nickname?.charAt(0).toUpperCase()}
            {member.nickname?.slice(1) ?? member.name ?? ""}
          </span>
        </button>
      ))}
    </div>
  );
}
